import { ColorSAP, FONT_FAMILY, Typography } from '../../ontego-ui';
import Styled from './FormStyles';

const Form = props => {
    const { id, number, multiline, rows, placeholder, label, containerStyle, value, onChange, onBlur, isPassword, whiteBackground, startAdornment, error, errorMessage, required, onClick } = props

    return (
        <div
            style={{
                width: '100%',
                ...containerStyle
            }}
            onClick={onClick}
        >
            {label && 
                <Typography
                    fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_SEMIBOLD}
                    size={14}
                    color={error ? ColorSAP.danger[60] : ColorSAP.neutral[100]}
                    style={{ marginBottom: 12, lineHeight: "17px" }}
                >
                    {label}{required ? "*" : ""}
                </Typography>
            }
            <Styled.CustomOutlinedInput
                whitebackground={whiteBackground}
                id={id}
                variant="outlined"
                startAdornment={startAdornment}
                value={value}
                multiline={multiline}
                rows={rows}
                placeholder={placeholder}
                error={error}
                onChange={onChange}
                onBlur={onBlur}
                type={isPassword ? 'password' : (number ? 'number' : 'text')}
            />
            {error && errorMessage && (
                <Typography
                    fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR}
                    size={12}
                    color={ColorSAP.danger[60]}
                    style={{ marginTop: 4 }}
                >
                    {errorMessage}
                </Typography>
            )}
        </div>
    )
}

export default Form